import { useState } from 'react'
import { IconPin, IconPinFilled } from '@tabler/icons-react'
import GalleryNavigation from './GalleryNavigation.tsx'
import { FileSelectionType } from '@/hooks/useFileSelection.tsx'
import { Album } from '@/models/album.ts'
import { DriveContact, HeyDrive } from '@/models/drive.ts'

interface GalleryNavigationDesktopProps {
  drive: HeyDrive
  albums: Album[]
  fileSelection: FileSelectionType
  onScrollToAlbum: (album: Album) => void
  contact: DriveContact | null
}

export default function GalleryNavigationDesktop({
  drive,
  albums,
  fileSelection,
  onScrollToAlbum,
  contact,
}: GalleryNavigationDesktopProps) {
  const [isPinned, setIsPinned] = useState(false)
  const [isHovered, setIsHovered] = useState(false)

  const isExpanded = isPinned || isHovered

  return (
    <div
      className={`hidden md:block flex-shrink-0 transition-[width] duration-300 ease-in-out overflow-visible ${
        isPinned ? 'w-64' : 'w-16'
      }`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className={`sticky top-0 h-screen bg-neutral flex flex-col transition-[width] duration-300 ease-in-out overflow-hidden ${
          isPinned
            ? 'w-64 border-r border-base-300'
            : isHovered
              ? 'w-64 z-50'
              : 'w-16 border-r border-base-200'
        }`}
      >
        {/* Pin button at the top */}
        <div className={`flex items-center h-12 flex-shrink-0 ${
          isExpanded ? 'justify-between px-4' : 'justify-center'
        }`}>
          {isExpanded && <span className='text-xs font-semibold uppercase tracking-wide opacity-50'>Navigation</span>}
          {isExpanded && (
            <button
              className='flex items-center gap-1 text-sm opacity-50 hover:opacity-100 transition-opacity'
              onClick={() => setIsPinned(!isPinned)}
              title={isPinned ? 'Loslösen' : 'Anheften'}
            >
              {isPinned ? <IconPinFilled size={16} /> : <IconPin size={16} />}
            </button>
          )}
        </div>

        {/* Navigation items */}
        <div className={`flex-1 overflow-y-auto overflow-x-hidden pt-2 ${isExpanded ? 'px-2' : ''}`}>
          <GalleryNavigation
            drive={drive}
            albums={albums}
            fileSelection={fileSelection}
            onScrollToAlbum={onScrollToAlbum}
            contact={contact}
            isExpanded={isExpanded}
          />
        </div>
      </div>
    </div>
  )
}
